module.exports = __webpack_public_path__ + "static/media/ic2.0f56b5b7.jpg";